module.exports = __webpack_public_path__ + "static/media/logo.b54defc0.png";